import { useEffect } from 'react';
import { useAIAssistant } from '../../components/AIAssistant';
import { useNavigate } from 'react-router-dom';

const AIAssistantPage = () => {
  const { setIsOpen } = useAIAssistant();
  const navigate = useNavigate();

  useEffect(() => {
    // When this page is mounted, open the AI Assistant
    setIsOpen(true);
    // Navigate back to dashboard to avoid duplicate rendering
    navigate('/dashboard');
  }, [setIsOpen, navigate]);

  return null; // This component doesn't render anything
};

export default AIAssistantPage;